import { Radio, RadioChangeEvent } from "antd";

type SlotChipProps = {
  value: string | number;
  isDisabled?: boolean;
  children: React.ReactNode;
  onChange?: (e: RadioChangeEvent) => void;
  onClick?: React.MouseEventHandler<HTMLElement>;
  className?: string;
};

/**
 * The use of flex here instead of dr-flex is intentionals
 * Will be changing it soon with class specificity
 */

const SelectSlotChip = ({
  value,
  isDisabled = false,
  children,
  onChange,
  onClick,
  className = "",
}: SlotChipProps) => {
  return (
    <div className="slot-chip-radio-button dr-flex dr-justify-center dr-items-center">
      <Radio.Button
        disabled={isDisabled}
        className={`BodyBody2Regular flex items-center justify-center dr-w-full ${className}`}
        style={{ borderRadius: "0.5rem" }}
        value={value}
        onChange={onChange}
        onClick={onClick}
      >
        {children}
      </Radio.Button>
    </div>
  );
};

export default SelectSlotChip;
